import { useLocation, useNavigate } from 'react-router-dom'
import { RoutePaths } from '@interfaces/routePaths'
import {
  ActionIcon,
  Anchor,
  Box,
  Button,
  Flex,
  Group,
  Menu,
  Stack,
  Text,
  TextInput,
  Timeline,
  Title,
  Tooltip,
} from '@mantine/core'
import {
  IconCaretDownFilled,
  IconFilterPlus,
  IconInfoCircle,
  IconSearch,
  IconSortDescending,
} from '@tabler/icons-react'
import baseClasses from '@styles/record.module.css'
import classes from './Activity.module.css'
import dataGridClasses from '@components/DataGrid/DataGrid.module.css'
import { useState } from 'react'
import cn from 'classnames'

export interface ActivityProps {
  fullWidth?: boolean
  state?: { history: any }
}

export const Activity = (props: ActivityProps) => {
  const { fullWidth, state } = props

  const navigate = useNavigate()
  const location = useLocation()
  const [activeSection, setActiveSection] = useState<string>('All Activity')

  const handleNavigate = () =>
    navigate(
      `../${RoutePaths.RECORD}/123/${RoutePaths.RECORD_HOME}`,
      location?.state?.history
        ? { state: location?.state }
        : state
        ? { state }
        : {},
    )

  const sections = [
    {
      label: 'All Activity',
      href: '#',
      default: true,
    },
    {
      label: 'My Activity',
      href: '#',
    },
  ]

  const activityItems = [
    [
      {
        type: 'updated',
        updater: {
          id: '123',
          name: 'You',
          persona: null,
        },
        updated: {
          id: '123',
          name: 'Joey Cadle',
          persona: 'contact',
        },
        date: 'Mar 11',
        time: '5:59pm',
      },
      {
        type: 'updated',
        updater: {
          id: '123',
          name: 'Lenny Kravitz',
          persona: 'Staff',
        },
        updated: {
          id: '123',
          name: 'Joey Cadle',
          persona: 'contact',
        },
        date: 'Mar 11',
        time: '5:59pm',
      },
      {
        type: 'updated',
        updater: {
          name: 'Others',
          persona: null,
        },
        updated: {
          id: '123',
          name: 'Joey Cadle',
          persona: 'contact',
        },
        date: 'Mar 11',
        time: '5:59pm',
      },
      {
        type: 'added',
        updater: {
          id: '123',
          name: `Children's Aid NYC`,
          persona: null,
        },
        updated: {
          id: '123',
          name: 'Joey Cadle',
          persona: 'community partner',
        },
        date: 'Mar 11',
        time: '5:59pm',
      },
      {
        type: 'request',
        requestType: 'edit access',
        updater: {
          id: '123',
          name: 'Joey Cadle',
          persona: 'Staff',
        },
        updated: {
          id: '123',
          name: 'Bob Barker',
          persona: 'record person',
        },
        date: 'Mar 11',
        time: '5:59pm',
      },
      {
        type: 'updated',
        updater: {
          id: '123',
          name: 'Alfredo Carrillo',
          persona: 'Contact',
        },
        updated: {
          id: '123',
          name: 'Rafael Carrillo',
          persona: 'child',
        },
        date: 'Mar 11',
        time: '5:59pm',
      },
      {
        type: 'updated',
        updater: {
          id: '123',
          name: 'Alfredo Carrillo',
          persona: 'Contact',
        },
        updated: {
          id: '123',
          name: 'Ryan Wiltzius',
          persona: 'record person',
        },
        date: 'Mar 11',
        time: '5:59pm',
      },
      {
        type: 'note',
        noteAction: 'added',
        updater: {
          id: '123',
          name: 'You',
          persona: null,
        },
        updated: {
          id: '123',
          name: 'Alfredo Carrillo',
          persona: 'contact',
        },
        date: 'Mar 11',
        time: '5:59pm',
      },
      {
        type: 'grant',
        grantType: 'edit access',
        updater: {
          id: '123',
          name: 'Alfredo Carrillo',
          persona: 'Contact',
        },
        updated: {
          id: '123',
          name: 'Alfredo Carrillo',
          persona: 'contact',
        },
        date: 'Mar 11',
        time: '5:59pm',
      },
    ],
    [
      {
        type: 'viewed',
        grantType: 'edit access',
        updater: {
          id: '123',
          name: 'Joey Cadle',
          persona: 'Staff',
        },
        updated: {
          id: '123',
          name: 'Alfredo Carrillo',
          persona: 'contact',
        },
        date: 'Mar 8',
        time: '11:12am',
      },
      {
        type: 'accepted',
        acceptedType: 'linked records',
        acceptedCount: 10,
        updater: {
          id: '123',
          name: 'Joey Cadle',
          persona: 'Staff',
        },
        updated: {
          id: '123',
          name: 'Alfredo Carrillo',
          persona: 'contact',
        },
        date: 'Mar 8',
        time: '11:12am',
      },
      {
        type: 'deleted',
        updater: {
          id: '123',
          name: 'Joey Cadle',
          persona: 'Staff',
        },
        updated: {
          id: '123',
          name: 'Bob Dylan',
          persona: 'record person',
        },
        date: 'Mar 8',
        time: '11:12am',
      },
      {
        type: 'deleted',
        bulk: 10,
        bulkType: 'linked records',
        updater: {
          id: '123',
          name: 'Joey Cadle',
          persona: 'Staff',
        },
        updated: {
          id: '123',
          name: 'Rafael Carrillo',
          persona: 'child',
        },
        date: 'Mar 8',
        time: '11:12am',
      },
    ],
  ]

  return (
    <Box className={cn({ [baseClasses.Record__content]: !fullWidth })}>
      <Group justify="space-between" p="md">
        {sections.length > 1 ? (
          <Menu position="bottom-start">
            <Menu.Target>
              <Group
                className={dataGridClasses.DataGrid__select}
                gap={3}
                align="center"
              >
                <Title order={4}>{activeSection}</Title>
                <IconCaretDownFilled size={18} />
              </Group>
            </Menu.Target>
            <Menu.Dropdown w={200}>
              {sections.map((curr, i) => (
                <Menu.Item
                  key={`sections-${i}`}
                  onClick={() => setActiveSection(curr.label)}
                >
                  <Text
                    size="md"
                    fw={activeSection === curr.label ? 'bold' : 'normal'}
                  >
                    {curr.label}
                  </Text>
                </Menu.Item>
              ))}
            </Menu.Dropdown>
          </Menu>
        ) : (
          <Title order={4}>{activeSection}</Title>
        )}
        <Text c="dimmed" size="sm">
          11 results
        </Text>
      </Group>
      <Flex justify="space-between" px="md" wrap="nowrap">
        <Group gap="xs" wrap="nowrap" mr="xs">
          <TextInput
            miw={275}
            style={{ flexShrink: 1 }}
            leftSection={<IconSearch size={22} />}
            leftSectionProps={{
              style: {
                color: 'var(--mantine-color-dark-2)',
              },
            }}
            rightSection={<IconInfoCircle size={18} />}
            rightSectionProps={{
              style: {
                color: 'var(--mantine-color-dark-3)',
                cursor: 'pointer',
              },
            }}
            placeholder="Search"
          />
          <Tooltip label="Add Filter">
            <div>
              <ActionIcon variant="default" h="100%" size="lg" c="dark.3">
                <IconFilterPlus size={22} />
              </ActionIcon>
            </div>
          </Tooltip>
        </Group>

        <Group gap="xs" wrap="nowrap">
          <Tooltip label="Sort Descending">
            <ActionIcon variant="default" h="100%" size="lg" c="dark.3">
              <IconSortDescending size={22} />
            </ActionIcon>
          </Tooltip>
          <Button>Add Note</Button>
        </Group>
      </Flex>

      <Box
        className={classes.Record__activity__subheading}
        px="lg"
        py="sm"
        mt="md"
      >
        <Title order={6}>Events</Title>
      </Box>
      <Box p="lg">
        <Stack gap={50}>
          {activityItems.map((item, i) => (
            <Timeline
              key={`timeline-${i}`}
              active={i == 0 ? item.length : undefined}
              bulletSize={18}
              lineWidth={3}
              styles={{
                itemTitle: {
                  textTransform: 'capitalize',
                },
              }}
            >
              {item.map((activity: any, x) => {
                return (
                  <Timeline.Item key={`timeline-item-${x}`}>
                    <Group gap={4}>
                      {activity.updater?.persona && (
                        <Text size="sm">{activity.updater.persona}</Text>
                      )}
                      {activity.updater.id ? (
                        <Anchor
                          c="dark.7"
                          fw="bold"
                          size="sm"
                          onClick={handleNavigate}
                        >
                          {activity.updater.name}
                        </Anchor>
                      ) : (
                        <Text size="sm">{activity.updater.name}</Text>
                      )}

                      {activity.type === 'request' && (
                        <Text size="sm">
                          requested {activity.requestType} to update{' '}
                          {activity.updated.persona}
                        </Text>
                      )}

                      {activity.type === 'viewed' && (
                        <Text size="sm">viewed {activity.updated.persona}</Text>
                      )}

                      {(activity.type === 'updated' ||
                        activity.type === 'deleted') && (
                        <>
                          <Text size="sm">{activity.type}</Text>
                          <Text size="sm">{activity.updated.persona}</Text>
                        </>
                      )}

                      {activity.type === 'grant' && (
                        <Text size="sm">was granted {activity.grantType}</Text>
                      )}

                      {activity.type === 'note' && (
                        <>
                          <Text size="sm">{activity.noteAction} a note to</Text>
                          <Text size="sm">{activity.updated.persona}</Text>
                        </>
                      )}

                      {activity.type === 'accepted' && (
                        <>
                          <Text size="sm">
                            accepted {activity.acceptedCount}{' '}
                            {activity.acceptedType} shared by
                          </Text>
                          <Text size="sm">{activity.updated.persona}</Text>
                        </>
                      )}

                      {activity.type === 'added' && (
                        <Text size="sm">
                          was added as a {activity.updated.persona}
                        </Text>
                      )}

                      {activity.type !== 'added' &&
                        activity.type !== 'grant' && (
                          <Anchor
                            c="dark.7"
                            fw="bold"
                            size="sm"
                            onClick={handleNavigate}
                          >
                            {activity.updated.name}
                          </Anchor>
                        )}

                      {activity.type === 'deleted' && activity.bulk && (
                        <Text size="sm">
                          including {activity.bulk} {activity.bulkType}
                        </Text>
                      )}
                    </Group>

                    <Text size="xs" mt={4} c="dimmed">
                      {activity.date}, {activity.time}
                    </Text>
                  </Timeline.Item>
                )
              })}
            </Timeline>
          ))}
        </Stack>
      </Box>
    </Box>
  )
}
